import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewEncapsulation } from "@angular/core";
import { AgrAction } from "../../bean/agr-action";
import { AgrBlockItem } from "../../bean/agr-block-item";

@Component({
  selector: "agr-block-list-item",
  templateUrl: "./agr-block-list-item.component.html",
  styleUrls: ["./agr-block-list-item.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class AgrBlockListItemComponent implements OnInit {
  @Input() blockItem: AgrBlockItem;
  @Input() id: string;

  @Input() showHeader: boolean;
  @Input() showInfoAdditional: boolean;
  @Input() showActions: boolean;
  @Input() showBorder: boolean;

  @Input() templateHeader: TemplateRef<any>;
  @Input() templateData: TemplateRef<any>;
  @Input() templateInfoAdditional: TemplateRef<any>;

  @Output() actionSelected: EventEmitter<AgrAction>;
  @Output() closeOption: EventEmitter<string>;

  public showOptions: boolean;

  constructor() {
    this.actionSelected = new EventEmitter<AgrAction>();
    this.closeOption = new EventEmitter<string>();
  }

  ngOnInit() {
    this.showActions =
      this.showActions &&
      this.blockItem.actions &&
      this.blockItem.actions.length > 0;
  }

  public openOptions($event): void {
    $event.stopPropagation();
    this.showOptions = !this.showOptions;
    this.closeOption.emit(this.id);
  }

  public hideOptions(): void {
    this.showOptions = false;
  }

  public sendAction($event, action: AgrAction): void {
    $event.stopPropagation();
    this.showOptions = false;
    const actionSender: AgrAction = Object.assign({}, action);
    actionSender.item = this.blockItem.item;
    this.actionSelected.emit(actionSender);
  }
}
